<nav class="console_menu">
    <ul class="list-unstyled menu_items" [ngClass]="{ streched: stretchMenu }">
        <li id="homeMenu" [routerLinkActive]="['active']">
            <a href="#" [routerLink]="['/dashboard']" ngbTooltip="Home" placement="right" [disableTooltip]="!stretchMenu" container="body">
                <i class="fas fa-home item_icon" aria-hidden="true"></i> Home
            </a>
        </li>
        @if (false) {   <!-- Temporarily disable Design menu -->
            <li
                #designAccordion
                [ngClass]="{ active: isChildActive(designAccordion, 'subDesign') && !subDesign }"
                *kaHasRoles="['design.entity.write', 'design.entity.read']; checkRealm: true"
            >
                <a
                    href="javascript:void(0)"
                    ngbTooltip="Design"
                    placement="right"
                    [disableTooltip]="!stretchMenu"
                    container="body"
                    (click)="subDesign = !subDesign"
                    [ngClass]="{ sub_open: subDesign, sub_closed: !subDesign }"
                >
                    <i class="fas fa-pencil-ruler item_icon" aria-hidden="true"></i> Design
                </a>
                <ul class="list-unstyled sub_items" [ngClass]="{ open: subDesign }">
                    <li id="entitiesMenu" [routerLinkActive]="['active']" *kaHasRoles="['design.entity.write', 'design.entity.read']; checkRealm: true">
                        <a href="#" [routerLink]="['/design/nlu-settings/entities']"> <i class="fa-solid fa-at item_icon" aria-hidden="true"></i> Entities </a>
                    </li>
                    <li id="processFlowsMenu" [routerLinkActive]="['active']" *kaHasRoles="['design.journey.write', 'design.journey.read']; checkRealm: true">
                        <a href="#" [routerLink]="['/process-flow']"> <i class="fas fa-shapes item_icon" aria-hidden="true"></i> Process flows </a>
                    </li>
                </ul>
            </li>
        }
        <li id="analyticsMenu" [routerLinkActive]="['active']" *kaHasRoles="['analytics.view']; checkRealm: true">
            <a href="#" [routerLink]="['/analytics']" ngbTooltip="Analytics" placement="right" [disableTooltip]="!stretchMenu" container="body">
                <i class="fas fa-chart-line item_icon" aria-hidden="true"></i> Analytics
            </a>
        </li>
        <li id="trainingMenu" [routerLinkActive]="['active']" *kaHasRoles="['training.write', 'training.read']; checkRealm: true">
            <a href="#" [routerLink]="['/agent-training']" ngbTooltip="Training" placement="right" [disableTooltip]="!stretchMenu" container="body">
                <i class="fas fa-chalkboard-teacher item_icon" aria-hidden="true"></i> Training
            </a>
        </li>
        @if (false) {    <!-- Temporarily disable -->        
            <li id="monitoringMenu" [routerLinkActive]="['active']" *kaHasRoles="['monitoring.status.view', 'monitoring.logs.view']; checkRealm: true">
                <a href="#" [routerLink]="['/monitoring']" ngbTooltip="monitoring" placement="right" [disableTooltip]="!stretchMenu" container="body">
                    <i class="fas fa-binoculars item_icon" aria-hidden="true"></i> Monitoring
                </a>
            </li>
            <li id="billingMenu" [routerLinkActive]="['active']" *kaHasRoles="['billing.view']; checkRealm: true">
                <a href="#" [routerLink]="['/billing']" ngbTooltip="Billing" placement="right" [disableTooltip]="!stretchMenu" container="body">
                    <i class="fas fa-coins item_icon" aria-hidden="true"></i> Billing
                </a>
            </li>
            <li id="adminMenu" [routerLinkActive]="['active']" *kaHasRoles="['admin.user.view', 'admin.user.editor', 'admin.training.write', 'admin.training.read', 'admin.auditlog.view']; checkRealm: true">
                <a href="#" [routerLink]="['/admin']" ngbTooltip="Admin" placement="right" [disableTooltip]="!stretchMenu" container="body">
                    <i class="fas fa-star item_icon" aria-hidden="true"></i> Admin
                </a>
            </li>
        }
    </ul>
</nav>
